import axios from "axios";
// import { auth } from "../lib/firebase";

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASEURL,
});

export const getAuthHeader = () => {
  // const { user } = await useAuthState();

  // const token = await auth.currentUser.getIdToken();

  // console.log(token);
  const token = sessionStorage?.getItem("token");
  // console.log(token, "TOKENNNN");
  if (token) {
    console.log("Access token available");
    return {
      headers: {
        Authorization: `${token}`,
      },
    };
  } else {
    // throw new Error("Access token not available");
    console.log("Access token not available");
  }
};

export const swrFetcher = async (url) => {
  const header = getAuthHeader();

  const auth = {
    method: "GET",
    ...header,
  };

  console.log(auth);

  if (header) {
    const res = await fetch(url, {
      ...auth,
    });
    return await res?.json();
  } else {
    const res_1 = await fetch(url);
    return await res_1?.json();
  }
};

export const apiFetcher = async (url) => {
  const res_1 = await fetch(url);
  return await res_1?.json();
};

//USERS
export const checkOrRegisterUser = (body) => {
  return api.post("/users/createForUser", body, getAuthHeader());
};

// PRODUCTS
export const fetchProducts = (page, limit, searchTerm, categoryId) => {
  let params = {
    page,
    limit,
    ...(searchTerm && { searchTerm }), // Only include if searchTerm is defined,
  };

  if (categoryId) {
    params = {
      ...params,
      categoryId,
    };
  }

  return api.get(`/product/paginated/user`, {
    params,
  });
};

export const fetchProductsString = (page, limit, searchTerm, categorySlug) => {
  let params = {
    page,
    limit,
    ...(searchTerm && { searchTerm }), // Only include if searchTerm is defined,
  };

  if (categorySlug) {
    params = {
      ...params,
      categorySlug,
    };
  }

  if (categorySlug) {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/product/paginated/user?page=${page}&limit=${limit}&searchTerm=${searchTerm}&categorySlug=${categorySlug}`;
  } else {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/product/paginated/user?page=${page}&limit=${limit}&searchTerm=${searchTerm}`;
  }

  // return api.get(`/product/paginated/user`, {
  //   params,
  // });
};

export const fetchGetProductBySlug = (slug) => api.get(`/product/slug/${slug}`);

export const fetchGetProductBySlugString = (slug) =>
  `${process.env.NEXT_PUBLIC_API_BASEURL}/product/slug/${slug}`;

// CATEGORY
export const fetchCategory = (parentId) => {
  let params = {};

  if (parentId) {
    params = {
      parentId,
    };
  }

  return api.get(`/category/getAll`, {
    params,
  });
};

export const fetchCategoryString = (parentId) => {
  if (parentId) {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/category/getAll?parentId=${parentId}`;
  } else {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/category/getAll`;
  }
};

export const getCategoryBySlug = (slug) => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/category/getBySlug/${slug}`;
};

export const fetchAllMenuCategory = () => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/category/menu/user`;
};

// NodeMailer
export const fetchReceiveEmail = (body) => {
  return api.post(`/node-mailer/receiveMail`, body);
};

//Favourite
export const fetchProductsFavouriteString = (
  page,
  limit,
  searchTerm,
  categorySlug,
) => {
  let params = {
    page,
    limit,
    ...(searchTerm && { searchTerm }), // Only include if searchTerm is defined,
  };

  if (categorySlug) {
    params = {
      ...params,
      categorySlug,
    };
  }

  if (categorySlug) {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/favourite/paginated/user?page=${page}&limit=${limit}&searchTerm=${searchTerm}&categorySlug=${categorySlug}`;
  } else {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/favourite/paginated/user?page=${page}&limit=${limit}&searchTerm=${searchTerm}`;
  }

  // return api.get(`/product/paginated/user`, {
  //   params,
  // });
};

export const favouriteActionString = () => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/favourite/action`;
};

export const favouriteAction = async (body) => {
  // const header = await getAuthHeader();

  return api.post(
    `${process.env.NEXT_PUBLIC_API_BASEURL}/favourite/action`,
    body,
    getAuthHeader(),
  );
};

//####################################################################
//#########################[BLOG API]#################################
//####################################################################

export const fetchAllBlog = (page, limit, searchTerm, categoryId) => {
  let params = {
    page,
    limit,
    ...(searchTerm && { searchTerm }), // Only include if searchTerm is defined,
  };

  if (categoryId) {
    params = {
      ...params,
      categoryId,
    };
  }

  return api.get(`/blogs/paginated/user`, {
    params,
  });
};

export const fetchAllBlogMenuCategory = () => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/blog-category/menu/user`;
};
export const getBlogCategoryBySlugUrl = (slug) => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/blog-category/getBySlug/${slug}`;
};

export const fetchBlogPostUrl = (page, limit, searchTerm, categorySlug) => {
  let params = {
    page,
    limit,
    ...(searchTerm && { searchTerm }), // Only include if searchTerm is defined,
  };

  if (categorySlug) {
    params = {
      ...params,
      categorySlug,
    };
  }

  if (categorySlug) {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/blogs/paginated/user?page=${page}&limit=${limit}&searchTerm=${searchTerm}&categorySlug=${categorySlug}`;
  } else {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/blogs/paginated/user?page=${page}&limit=${limit}&searchTerm=${searchTerm}`;
  }
};

export const getBlotPostBySlugUrl = (slug) => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/blogs/getBySlug/${slug}`;
};

//####################################################################
//#########################[TOOLS API]################################
//####################################################################

export const fetchAllTools = (page, limit, searchTerm, categoryId) => {
  let params = {
    page,
    limit,
    ...(searchTerm && { searchTerm }), // Only include if searchTerm is defined,
  };

  if (categoryId) {
    params = {
      ...params,
      categoryId,
    };
  }

  return api.get(`/tools/paginated/user`, {
    params,
  });
};

export const getAllToolsData = (page, limit, searchTerm, categorySlug) => {
  let params = {
    page,
    limit,
    ...(searchTerm && { searchTerm }), // Only include if searchTerm is defined,
  };

  if (categorySlug) {
    params = {
      ...params,
      categorySlug,
    };
  }

  if (categorySlug) {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/tools/paginated/user?page=${page}&limit=${limit}&searchTerm=${searchTerm}&categorySlug=${categorySlug}`;
  } else {
    return `${process.env.NEXT_PUBLIC_API_BASEURL}/tools/paginated/user?page=${page}&limit=${limit}`;
  }
};

export const getToolBySlugApi = (slug) => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/tools/getBySlug/${slug}`;
};

//===========TOOLS CATEGORY
export const fetchAllToolsMenuCategory = () => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/tools-category/menu/user`;
};

export const getToolsCategoryBySlugUrl = (slug) => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/tools-category/getBySlug/${slug}`;
};

//==================ALL REVIEWS=======================

export const getReviewByType = (itemId, type, page, limit) => {
  return `${process.env.NEXT_PUBLIC_API_BASEURL}/review/paginated/user?itemId=${itemId}&type=${type}&page=${page}&limit=${limit}`;
};
export const addReview = (body) => {
  return api.post("/review/create", body, getAuthHeader());
};
export const editReview = (id, body) => {
  return api.put(`/review/update/${id}`, body, getAuthHeader());
};
export const deleteReview = (id) => {
  return api.delete(`/review/delete/${id}`, getAuthHeader());
};
